import {getConfig} from 'config';
import {getData} from '../dataProvider';

export const loadDashboard = queryString => {
  return getData(`${getConfig('dashboardUrl')}${queryString}`);
};

export const loadClients = (filterText, cursor, signal) => {
  if (cursor) {
    const apiScheme = new URL(getConfig('apiDomain')).protocol;
    cursor = cursor.replace(/^https?:/, apiScheme);
  }
  const filter = filterText ? '?search=' + filterText : '';
  let url = cursor || `${getConfig('clientsUrl')}${filter}`
  return fetch(url, { signal, credentials: 'include'});
}
